import React, { useEffect, useState } from "react";
import { Row, Col, Form, Input, Select, TimePicker, Button } from "antd";
import map from "lodash/map";
import get from "lodash/get";
import find from "lodash/find";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";

import { fetchScopeNodeHierarchy } from "../../../redux/actions/locationActions";
import { getLocationInputValue } from "../../../utilities/location";
import { fetchCompanyStaffs } from "../../../redux/actions/companyActions";

const BasicInfo = ({
  initialValues,
  onSelectLocation,
  edit,
  onSubmitFormValue,
  setLoading,
  toggle,
  companies,
  locationId,
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [staffs, setStaffs] = useState([])
  const getCompanyStaff = (company_uuid) => {
    setLoading(true);
    dispatch(fetchCompanyStaffs(company_uuid, { role_id: 1 }))
      .then((result) => {
        setLoading(true);
        setStaffs(result);
      })
      .catch(() => {
      });
  };
  const onFinish = (values) => {
    onSubmitFormValue(values, 1);
  };
  const [templateTypes, setTemplateTypes] = useState([])
  const onFinishFailed = () => { };

  const getLocation = (locationId) => {
    setLoading(true);
    dispatch(fetchScopeNodeHierarchy("LOCATION", locationId))
      .then((result) => {
        setLoading(false);
        form.setFieldsValue({
          location_id: getLocationInputValue(result),
        });
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (edit) {
      getLocation(locationId);
    }
    if(get(initialValues, "company_id")){
      getCompanyStaff(get(initialValues, "company_id"))
    }
  }, []);

  useEffect(() => {
    if (initialValues && get(initialValues, 'company_id') && get(companies, 'length') > 0) {
      const company = find(companies,
        (comp) => comp.id === get(initialValues, 'company_id')
      );
      if (company) {
        setTemplateTypes(get(company, 'template_access_list'));
      }
    }
  }, [initialValues, companies]);
  return (
    <div className="w-full h-full flex flex-col py-10">
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        scrollToFirstError
        requiredMark={false}
        className="flex-grow overflow-y-auto px-4"
        initialValues={initialValues}
      >
        <Row gutter={10}>
          <Col xl={8} xs={24}>
            <Form.Item
              label="Company"
              name="company_id"
              rules={[
                {
                  required: true,
                  message: "Please select Company",
                },
              ]}
            >
              <Select
                placeholder="Select Company"
                optionFilterProp="label"
                showSearch
                onChange={(value) => {
                  const selectedCompany = companies.find(
                    (company) => get(company, "id") === value
                  );
                  onSelectLocation(get(selectedCompany, "location_id"));
                  setTemplateTypes(get(selectedCompany, "template_access_list"))
                  form.setFieldsValue({
                    type_id: undefined,
                    name: undefined,
                    manager_uuid:undefined
                  });
                  getCompanyStaff(get(selectedCompany, "id"))
                }}
                options={map(companies, (company) => ({
                  label: get(company, "name"),
                  value: get(company, "id"),
                }))}
                disabled={edit}
              />
            </Form.Item>
          </Col>

          <Col xl={8} xs={24}>
            <Form.Item
              name="name"
              label="Machine Name"
              rules={[
                {
                  required: true,
                  message: "Please input Machine name...!",
                },
              ]}
            >
              <Input placeholder="Machine name" className="input-space" />
            </Form.Item>
          </Col>

          <Col xl={8} xs={24}>
            <Form.Item
              name="type_id"
              label="Template"
              rules={[
                {
                  required: true,
                  message: "Please select Template...!",
                },
              ]}
            >
              <Select
                placeholder={"Select Template"}
                style={{ width: "100%" }}
                onSelect={(val) => { }}
                disabled={edit}
                options={map(templateTypes, (template) => {
                  return {value:get(template, "value"), label:get(template, "name")}
                })}
              />
            </Form.Item>
          </Col>
          <Col xl={8} xs={24}>
            <Form.Item
              name="reset_time"
              label="Reset Time"
              rules={[
                {
                  required: true,
                  message: "Please select Reset time...!",
                },
              ]}
            >
              <TimePicker
                onChange={() => { }}
                className="w-full"
                format={"HH:mm"}
                minuteStep={15}
                defaultOpenValue={dayjs("08:00:00", "HH:mm:ss")}
              />
            </Form.Item>
          </Col>
          <Col xl={8} xs={24}>
            <Form.Item
              label="Staff Manager"
              name="manager_uuid"
              rules={[
                {
                  required: true,
                  message: "Please select Staff Manager",
                },
              ]}
            >
              <Select
                placeholder="Staff Manager"
                optionFilterProp="label"
                showSearch
                options={map(staffs, (staff) => ({
                  label: get(staff, "name"),
                  value: get(staff, "id"),
                }))}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <div className="w-full bg-white p-4">
        <div className="flex justify-end space-x-2">
          <Button
            onClick={() => {
              toggle();
            }}
            className="border-gray-300"
          >
            Cancel
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            onClick={() => form.submit()}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BasicInfo;
